/* tslint:disable */
/* eslint-disable */
/**
 * Sports App Training Plans
 * API for the Sports App Training Plans
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { HTTPLink } from './HTTPLink';
import {
    HTTPLinkFromJSON,
    HTTPLinkFromJSONTyped,
    HTTPLinkToJSON,
    HTTPLinkToJSONTyped,
} from './HTTPLink';

/**
 * 
 * @export
 * @interface ExerciseCategoryDTO
 */
export interface ExerciseCategoryDTO {
    /**
     * 
     * @type {string}
     * @memberof ExerciseCategoryDTO
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof ExerciseCategoryDTO
     */
    name: string;
    /**
     * 
     * @type {string}
     * @memberof ExerciseCategoryDTO
     */
    description: string;
    /**
     * 
     * @type {string}
     * @memberof ExerciseCategoryDTO
     */
    imageId?: string;
    /**
     * 
     * @type {Array<HTTPLink>}
     * @memberof ExerciseCategoryDTO
     */
    links: Array<HTTPLink>;
}

/**
 * Check if a given object implements the ExerciseCategoryDTO interface.
 */
export function instanceOfExerciseCategoryDTO(value: object): value is ExerciseCategoryDTO {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('description' in value) || value['description'] === undefined) return false;
    if (!('links' in value) || value['links'] === undefined) return false;
    return true;
}

export function ExerciseCategoryDTOFromJSON(json: any): ExerciseCategoryDTO {
    return ExerciseCategoryDTOFromJSONTyped(json, false);
}

export function ExerciseCategoryDTOFromJSONTyped(json: any, ignoreDiscriminator: boolean): ExerciseCategoryDTO {
    if (json == null) {
        return json;
    }
    return {
        
        'id': json['id'],
        'name': json['name'],
        'description': json['description'],
        'imageId': json['imageId'] == null ? undefined : json['imageId'],
        'links': ((json['links'] as Array<any>).map(HTTPLinkFromJSON)),
    };
}

export function ExerciseCategoryDTOToJSON(json: any): ExerciseCategoryDTO {
    return ExerciseCategoryDTOToJSONTyped(json, false);
}

export function ExerciseCategoryDTOToJSONTyped(value?: ExerciseCategoryDTO | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'id': value['id'],
        'name': value['name'],
        'description': value['description'],
        'imageId': value['imageId'],
        'links': ((value['links'] as Array<any>).map(HTTPLinkToJSON)),
    };
}

